/**
 * Shared drag state module
 * 
 * Browser security restrictions prevent reading dataTransfer.getData() during
 * dragover and dragstart events (only available during drop). This module
 * provides a way to share drag metadata between components during drag operations.
 * 
 * Usage:
 * - VaultDrawer calls setDragState() when drag starts with element dimensions
 * - SmartEditor reads getDragState() during dragover for edge-based auto-scroll
 * - Both call clearDragState() when drag ends
 */

let currentDragState = null;

/**
 * Set the current drag state with element dimensions
 * @param {Object} state - Drag state object
 * @param {number} state.width - Width of the dragged element
 * @param {number} state.height - Height of the dragged element
 * @param {string} state.type - Type of drag (e.g., 'vault-asset')
 * @param {string} state.assetType - Asset type if applicable (image, video, etc.)
 */
export const setDragState = (state) => {
    currentDragState = state;
    console.log('[DragState] Set drag state:', state);
};

/**
 * Get the current drag state
 * @returns {Object|null} Current drag state or null if no drag in progress
 */
export const getDragState = () => {
    return currentDragState;
};

/**
 * Clear the drag state (call when drag ends)
 */
export const clearDragState = () => {
    console.log('[DragState] Cleared drag state');
    currentDragState = null;
};

/**
 * Check if a drag is in progress
 * @returns {boolean} True if drag is in progress
 */
export const isDragging = () => {
    return currentDragState !== null;
};

export default {
    setDragState,
    getDragState,
    clearDragState,
    isDragging
};
